import React, { useState } from "react";
import Result, { IClientData } from "./Result";
import RecommendProducts from "./RecommendProducts";
import { Link } from "react-router-dom";

interface IProps {
  onChange: () => void;
}
const VinResult: React.SFC<IClientData & IProps> = ({onChange, ...props}) => {

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="res mt-md-3">
              <h2 className="res__title">Результат поиска</h2>
              <Result {...props} />
              <div className="vin-result-btn"><button className="btn" onClick={onChange}>Вернуться к поиску</button></div>
            </div>
          </div>
          <div className="col-12 col-lg-6 prod recommend-products__prod">
            <div className="row w-100 mx-0 d-flex justify-content-between align-items-center kost">
              <div className="prod__title">
                Рекомендуемые товары
                {/* <br className="d-md-none" /> для клиента */}
              </div>
              <Link to={"/home/catalog"}><button className="btn px-0 py-0 d-md-block">
                Все товары
              </button></Link>
            </div>
            <div className="row w-100 no-gutters recommend-product">
              <RecommendProducts recommendProducts={props.products} />
            </div>
          </div>
          {/* <Link to={"/home/catalog"}>
          <button className="btn px-0 py-0 d-md-none np">Все товары</button></Link> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default VinResult;
